
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setFieldValue from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SetFieldValue";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Checkbox from "@insite/mobius/Checkbox";
import CheckboxGroup from "@insite/mobius/CheckboxGroup";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import isEmpty from "lodash/isEmpty"
import * as React from "react";
import { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const enum fields {
    label = "label",
    checkboxFieldValue = "checkboxFieldValue",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.label]: string;
    };
}

const mapStateToProps = (state: ApplicationState) => {
    return {
      PreferredMethodOfContact: state.components.contactUsForm.fieldValues["PreferredMethodOfContact"],
      contactUsFormstate: state.components.contactUsForm.fieldValues,
    }
};

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface PreferredMethodOfContactStyles {
    preferredMethodWrapper?: InjectableCss;
    preferredMethodCheckbox?: InjectableCss;
}

export const preferredMethodOfContactStyles: PreferredMethodOfContactStyles = {
    preferredMethodWrapper: {
        css: css`
            font-family: "MontserratRegular";
            > ${TypographyStyle} {
                font-size: 16px;
                font-weight: 600;
                font-family: "MontserratRegular";
                color: ${getColor("text.accent")};
            }
        `,
    },

    preferredMethodCheckbox: {
        css: css`
            span[role="checkbox"] {
                background: ${getColor("common.background")};
                &:focus {
                    outline: none;
                    box-shadow: none;
                }
            }
        `,
    },
};

const styles = preferredMethodOfContactStyles;

const PreferredMethodOfContact: React.FC<Props> = ({ fields, PreferredMethodOfContact, contactUsFormstate, setFieldValue }) => {
    const { label } = fields;

    const [isPhone, setIsPhone] = React.useState(false);
    const [isEmail, setIsEmail] = React.useState(false);

    const phoneHandler = (phone: boolean) => {
        setIsPhone(phone);
    };

    const emailHandler = (email: boolean) => {
        setIsEmail(email);
    };

    const getValue =  () => {
        const methodofContact = []
        if(isPhone) {
             methodofContact.push("Phone")
        }
        if(isEmail) {
            methodofContact.push("Email")
        }
        return  methodofContact.toString();
    }

    useEffect ( () => {
        setFieldValue({ key: "methodOfContact", value: getValue() });
    },[isPhone,isEmail]);


    useEffect ( () => {
        if(isEmpty(contactUsFormstate)) {
            setIsPhone(false);
            setIsEmail(false);
        }
    },[contactUsFormstate]) ;

    return (
        <CheckboxGroup
            label={label}
            name="ListforPrefredWay"
            {...styles.preferredMethodWrapper}
            >
            <Checkbox
                {...styles.preferredMethodCheckbox}
                data-test-selector="preferred_method_of_Contact_Phone"
                onChange={(e, value) => phoneHandler(value)}
                checked={isPhone}
            >
                {translate("Phone")}
            </Checkbox>

            <Checkbox
                {...styles.preferredMethodCheckbox}
                data-test-selector="preferred_method_of_Contact_Email"
                onChange={(e, value) => emailHandler(value)}
                checked={isEmail}
            >
                {translate("Email")}
            </Checkbox>
        </CheckboxGroup>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(PreferredMethodOfContact),
    definition: {
        group: "Contact Us",
        icon: "input-pipe",
        fieldDefinitions: [
            {
                name: fields.label,
                displayName: "Label",
                editorTemplate: "TextField",
                fieldType: "General",
                defaultValue: "Preferred Method of Contact",
            },
        ],
    },
};

export default widgetModule;
